export default __webpack_public_path__ + "static/media/times-solid.de9fddb2.svg";